(() => {
  window.addEventListener('load', () => {
    const showAllThemeItemsButtons = document.querySelectorAll(
      '.js_show_all_themes',
    );
    if (showAllThemeItemsButtons) {
      showAllThemeItemsButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetSelector = button.getAttribute('aria-controls');
          button.classList.add('d-none');
          button.classList.remove('d-inline-flex');
          button.setAttribute('aria-expanded', 'true');
          if (targetSelector) {
            document
              .querySelector('#' + targetSelector)
              ?.classList.remove('show-first-2');
          }
        });
      });
    }
  });
})();
